import { PropsWithChildren } from 'react'
import { ThemeProvider as AntdThemeProvider } from '@vivaldis/ui'

export const ThemeProvider = ({ children }: PropsWithChildren<unknown>) => {
  return <AntdThemeProvider>{children}</AntdThemeProvider>
}
